var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceAsset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 20 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.42 14.2386L16.87 12.7086L4.77 0.598615C4.62788 0.455426 4.45483 0.34672 4.26414 0.280845C4.07345 0.214971 3.8702 0.193683 3.67 0.218615C2.75051 0.275983 1.85697 0.546443 1.06 1.00862C0.350001 1.54862 0 2.73861 0 4.59861V27.0186C0 28.9586 0.350001 30.1686 1.06 30.6286C1.87496 31.0467 2.76628 31.295 3.68 31.3586C3.88259 31.388 4.08924 31.3699 4.28363 31.3057C4.47801 31.2415 4.65479 31.1329 4.8 30.9886L18.42 17.3786C18.8334 16.9627 19.0655 16.4001 19.0655 15.8136C19.0655 15.2272 18.8334 14.6646 18.42 14.2486",
    fill: "#F5F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceAsset);
export default __webpack_public_path__ + "static/media/priceAsset.c4117374757af6cda5ffe2406c4d71ff.svg";
export { ForwardRef as ReactComponent };